import { techDocs } from "../technical-docs";

export default techDocs('wood', 'Madeira', 'documentos-tecnicos-madeira')